// extracted by mini-css-extract-plugin
module.exports = {"root":"Carousel_root__19sCr","threeToTwoWrapper":"Carousel_threeToTwoWrapper__3CXX4","aspectWrapper":"Carousel_aspectWrapper__3u82h","rootForImage":"Carousel_rootForImage__28YWK"};